import { render, staticRenderFns } from "./RequestSong.vue?vue&type=template&id=7985e621&"
import script from "./RequestSong.vue?vue&type=script&lang=js&"
export * from "./RequestSong.vue?vue&type=script&lang=js&"
import style0 from "./RequestSong.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports